// @ts-nocheck
import {
    getHomePageUrl,
    getPageLinkByNodeId,
    getPageLinkByPageType,
} from "@insite/client-framework/Store/Links/LinksSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useHomePageUrl = convertSelectorToHook(getHomePageUrl);
export const usePageLinkByNodeId = convertSelectorToHook(getPageLinkByNodeId);
export const usePageLinkByPageType = convertSelectorToHook(getPageLinkByPageType);
